export default {
  useMoreAddress: 'Usar outro endereço',
  hideAddress: 'Recolher endereço',
  productInventory: 'Lista de produtos',
  tag: 'Etiqueta',
  retainTag: 'Manter etiqueta',
  delTag: 'Remover etiqueta',
  externalPack: 'Embalagem externa',
  packDetail: 'Detalhes da embalagem',
  postLine: 'Rota de envio',
  selectLine: 'Selecionar rota',
  editLine: 'Modificar rota',
  service: 'Serviço',
  cancelServe: 'Cancelar serviço',
  previewPackage: 'Pré-visualizar pacote',
  postCountry: 'País de envio',
  packageNo: 'Número do pacote',
  deliver: 'Enviar para',
  packageDetail: 'Detalhes do pacote',
  addressInfo: 'Informações de endereço',
  voWeight: 'Peso volumétrico',
  firstWeight: 'Primeiro peso',
  continueWeight: 'Peso adicional',
  actWeight: 'Peso real',
  packageStatus: 'Status do pacote',
  freightDetail: 'Informações de custo',
  declareCurrency: 'Moeda de declaração',
  selfDeclare: 'Declaração própria',
  packageDeclarePrice: 'Preço total declarado do pacote',
  youPackageProduct: 'Produtos no seu pacote',
  editYourDeclare: 'Por favor, edite suas informações de declaração',
  startDeclare: 'Começar declaração',
  declareType: 'Tipo de declaração',
  productNo: 'Número do produto',
  declareProductPrice: 'Preço unitário declarado do produto',
  declareTotalPrice: 'Valor total declarado do produto',
  editDeclare: 'Modificar declaração',
  declareLinePriceHint: 'Valor total declarado mínimo da rota atual: {min} Máximo: {max}',
  classMaxNumHint: 'A quantidade de uma única categoria atingiu o limite {max}',
  addDeclareProduct: 'Adicionar produto de declaração',
  plsConfirmInfo: 'Por favor, confirme as informações',
  wipePackProduct: 'Remover produto de embalagem',
  foldPackProduct: 'Dobrar produto de embalagem',
  wipeTagProduct: 'Remover produto de etiqueta',
  aboutCalcWeightExplain:
    'Como o pacote atual não foi empacotado, não sabemos o peso real do pacote nesta fase, portanto, só podemos estimar o peso do pacote com base em alguns parâmetros existentes, cobrar um depósito e fazer reembolso ou complemento após o empacotamento do pacote e obtenção do peso real.',
  expressInfo: 'Informações de logística',
  deliveryMode: 'Método de entrega',
  targetCountry: 'País de destino',
  cancelPackage: 'Cancelar pacote',
  cancelPackageHint:
    'Tem certeza de que deseja cancelar este pacote? Após o cancelamento, não poderá ser restaurado.',
  isDelPackage: 'Tem certeza de que deseja excluir permanentemente o pacote?',
  delPackageHint:
    'Após a exclusão permanente, você não poderá mais visualizar o pacote, por favor, opere com cuidado!',
  receivedTips: 'Seu pacote foi recebido, bem-vindo para usar novamente',
  packageQuestion: 'Ocorreu um problema no processo de envio do pacote, você pode',
  afterSale: 'Solicitar serviço pós-venda',
  repair: 'Pagamento adicional',
  ucan: 'Você pode',
  clickAdd: 'Clique para adicionar',
  addCategoryTips: 'Acima não há o nome do produto que você deseja declarar',
  noCarrierLines: 'Sem rotas de envio disponíveis',
  confirmPackageTitle: 'Confirmou que recebeu a mercadoria?',
  confirmPackageTips:
    'Para proteger seus direitos pós-venda, por favor, confirme o recebimento após receber o pacote e confirmar que está correto',
  receiptSuccess: 'Recebimento bem-sucedido',
  position: 'Localização',
  time: 'Hora',
  duty: 'Número fiscal',
  inputTrueDuty: 'Por favor, insira o número fiscal correto',
  serveStatusEnum: {
    1: 'Fotos personalizadas',
    2: 'Estender período de armazenamento',
    5: 'Inspeção de qualidade em vídeo',
  },
  inputCareTime: 'Por favor, selecione o tempo de armazenamento',
  holder: {
    noInputSearch: 'Número do pacote/número do produto',
    inputEditDeclareInfo: 'Por favor, edite suas informações de declaração',
    packageRemark:
      'Se você tiver outros requisitos especiais para o pacote, por favor, deixe uma nota aqui',
    yourPriceSummary: 'Seu resumo de preços',
  },
  calcFee: 'Custo estimado',
  realFee: 'Custo real',
  declare: {
    repeatDeclare: 'Tipo de declaração repetido',
    addDeclareType: 'Por favor, adicione o tipo de declaração',
  },
  feeEnum: {
    totalAmount: 'Depósito estimado',
    deposit: 'Custo estimado',
    overLongFee: 'Taxa por comprimento excessivo',
    overWeightFee: 'Taxa por peso excessivo',
    remoteFee: 'Taxa de área remota',
    feeCustoms: 'Taxa de processamento do fornecedor de logística',
    feeFuel: 'Taxa de combustível',
    feeOperation: 'Taxa de operação',
    feeService: 'Taxa de serviço',
    valueAddedTax: 'IVA',
    insuranceService: 'Prêmio de seguro',
    incrementAmount: 'Taxa de serviço de valor agregado',
    lineDiscount: 'Desconto de rota',
    discount: 'Desconto vip',
    coupon: 'Selecionar cupom',
    passwordDiscount: 'Código de desconto',
    orderPreDiscount: 'Desconto do produto',
    insuranceDiscount: 'Desconto de seguro',
    incrementDiscount: 'Desconto de serviço de valor agregado',
    preVolumeCal: 'Pesagem estimada',
    actDeposit: 'Frete após pesagem',
    actDepositAmount: 'Pagamento final necessário',
  },
  ratePaymentEnum: {
    name: 'Método de pagamento de impostos',
    0: 'Destinatário paga',
    1: 'GST/VAT da plataforma',
    2: 'GST/VAT pessoal',
    3: 'IOSS da plataforma',
    4: 'IOSS pessoal',
    5: 'GST/VAT da empresa',
    6: 'GST/VAT do fornecedor de logística',
    7: 'IOSS do fornecedor de logística',
    8: 'Isento de impostos',
  },
  bagStatusEnum: {
    0: 'Pacote normal',
    1: 'Pacote devolvido doméstico',
    2: 'Pacote devolvido no exterior',
    3: 'Pacote cancelado',
    4: 'Pacote de pagamento adicional',
  },
  packageStatusEnum: {
    0: 'Aguardando processamento',
    1: 'Em processamento',
    2: 'Saindo do armazém',
    3: 'Saiu do armazém',
    4: 'Empacotado',
    5: 'Pesado',
    6: 'Número de guia impresso',
    7: 'Verificado',
    8: 'Transferido',
    9: 'Enviado',
    20: 'Confirmar recebimento',
  },
  declareEnum: {
    name: 'Método de declaração',
    0: 'Declaração vaga',
    1: 'Declaração própria',
  },
  backText: 'Voltar',
  packageInformation: 'Informações do pacote',
  parcelNumber: 'Status do pacote',
  noValidRule: 'Valor declarado não passa na regra: {rule}',
  shippingAgree: 'Acordo de transporte de pacote acbuy',
  haveDiscountCode: 'Tenho código de desconto',
  inputDiscountCode: 'Insira o código de desconto aqui',
  expressNo: 'Número da guia de logística',
  shipping: 'Frete',
  taxation: 'Impostos',
  acCare: 'Prêmio de seguro',
  discountCode: 'Código de desconto',
  coupon: 'Cupom',
  rangeDeclare: 'Seu valor declarado está fora do intervalo',
  noCouponData: 'Não há cupons que atendam às condições de desconto de frete.',
  exchange: 'Trocar',
  'i18n-000001': 'Material',
  'i18n-000002': 'Cor',
  'i18n-000003': 'Modelo/Tamanho',
  'i18n-000004': 'Material',
  'i18n-000005': 'Se declarar',
  'i18n-000006': 'Lembrete amigável',
  'i18n-000007':
    'Após o envio, nossa empresa não modificará estas informações de declaração. Após a falha na pré-liberação alfandegária, continuaremos enviando.',
  'i18n-000008':
    '1. De acordo com os requisitos da alfândega brasileira, por favor, declare detalhadamente o nome do produto, material, cor, modelo/tamanho, o número total de nomes de produtos declarados não excederá 5;',
  'i18n-000009':
    '2. Como os pacotes pequenos do Brasil são para uso pessoal, quando vários pacotes chegam à alfândega ao mesmo tempo, serão apreendidos. Para vários produtos, por favor, envie separadamente;',
  'i18n-000010':
    '3. Recomenda-se que um único pacote não exceda 4KG, cada produto declarado não seja inferior a 3USD. Para produtos de alto valor (consoles de jogos, celulares, tablets, computadores, etc.), declare o mais verdadeiro possível para evitar apreensão alfandegária;',
  'i18n-000011':
    '4. Padrão de tributação local do Brasil: Declaração abaixo de 50 dólares, calculado como 17% ICMS + 20% Duty, acima de 50 dólares, calculado como 17% ICMS + 60% Duty, apenas para referência;',
  'i18n-000012':
    '5. Após o pacote chegar ao Brasil, por favor, preste atenção a mensagens de texto e e-mails e pague os impostos a tempo',
  'i18n-000013': '{ num } peças',
  'i18n-000014': 'Nome do produto',
  cartonWarning:
    'O tamanho e peso do seu pacote são muito grandes. Recomendamos que você escolha embalagem de papelão para reduzir o risco de danos ao pacote e ter melhor efeito de compressão',
  'i18n-0000003': 'Número do pacote',
  'i18n-0000004': 'Hora de envio',
  'i18n-0000005': 'Volume estimado do pacote',
  'i18n-0000006': 'Peso estimado do pacote',
  'i18n-0000007': 'Custo estimado',
  'i18n-0000009': 'Nome da logística',
  'i18n-0000010': 'Número da guia de logística',
  'i18n-0000011': 'Aguardando pagamento',
  'i18n-0000017': 'Valor do desconto',
  'i18n-0000018': 'Informações de endereço de entrega',
  'i18n-0000019': 'Informações de declaração',
  'i18n-0000020': 'Nome declarado',
  'i18n-0000021': 'Valor declarado($)',
  'i18n-0000022': 'Quantidade',
  'i18n-0000023': 'Subtotal($)',
  'i18n-0000024': 'Total declarado',
  'i18n-0000025': 'Informações do produto',
  'i18n-0000026': 'Nome do produto',
  'i18n-0000027': 'Peso(g)',
  'i18n-0000028': 'Volume(cm³)',
  'i18n-0000029': 'Detalhes da embalagem',
  'i18n-0000033': 'Aguardando reembolso',
  'i18n-0000034': 'Aguardando pagamento adicional',
  'i18n-0000035': 'Volume real do pacote',
  'i18n-0000036': 'Peso de cobrança do pacote',
  'i18n-0000037': 'Custo real',
  'i18n-0000038': 'Pagamento real',
  'i18n-0000039': 'Fotos de empacotamento',
  'i18n-0000040': 'Baixar fatura do pacote',
  'i18n-0000041': 'Saldo reembolsado',
  'i18n-0000042': 'Reembolso',
  'i18n-0000043': 'Pagamento adicional',
  'i18n-0000046': 'Expandir',
  'i18n-0000047': 'Recolher',
  'i18n-0000048': 'Rastreamento de logística',
  'i18n-0000049': 'Informações de pesagem',
  'i18n-0000050': 'Reembolso',
  'i18n-0000051': 'Reembolso estimado em 72 horas',
  samePreviewTips: 'Este pacote de pré-visualização já foi enviado, deseja enviar novamente?',
  confirmSubmitTitle: 'Confirmar e continuar',
  confirmSubmitText: 'Por favor, confirme seu endereço de entrega:',
  confirmSubmitContent: `Endereço de entrega: {address}

Aviso importante: O peso de cobrança exibido atualmente é uma estimativa. O peso de cobrança final será baseado no valor real medido após o empacotamento, geralmente cobrado com base no maior valor entre peso volumétrico e peso real. Se houver diferença entre o custo final e a estimativa, será processado de acordo com o princípio de "reembolso ou complemento". `,
}
